import styled from "styled-components"
import {Para} from "@irati/ui/src/Labels"

const StyledPara = styled(Para)`
  max-width: ${(props) => (props.isMobile ? "100%" : "calc(100% - 130px)")};
  word-wrap: break-word;
`

export default StyledPara
